<mat-card class="example-card tile_list" style="height: 100%;min-height: 463px">
  <mat-card-header>
    <div class="flex lg:flex-row md:flex-col gap-[20px]">
      <div class="flex-[80%]">
        <mat-card-title>{{UIDisplay}} List</mat-card-title>
      </div>
      <div class="flex-[20%]">
        <button mat-icon-button align="end" style="visibility: hidden;">
          Temp
        </button>
      </div>
    </div>
  </mat-card-header>
  <mat-divider></mat-divider>
  <mat-card-content style="margin-bottom: 0px;">
    <app-custom-select-create-autocomplete #subTileList [addAll]="false" [value]="selectedCategory"
      [dataType]="'category'" [dataTypeDisplay]="'Category'" [placeholder]="'Category'" [useOrg]="true"
      [canDelete]="false" (onSelectReturn)="selectCategory($event)" [type]="'tile'" [onBlur]="false"
      [orgId]="selectedOrganization">
    </app-custom-select-create-autocomplete>
    <mat-form-field *ngIf="hasTypeField" class="w-full">
      <mat-label>{{"Type" | translate}}</mat-label>
      <mat-select ng-model="tileType" [disabled]="!isSuperAdmin" (selectionChange)="selectTileType($event.value)"
        [value]="selectedTileType">
        <mat-option value="">{{'All' | translate}}</mat-option>
        <mat-option *ngFor="let itm of typeMeta.enum" [value]="itm.value">
          {{itm.displayName | translate}}</mat-option>
      </mat-select>
    </mat-form-field>
    <mat-form-field *ngIf="enablePaidContent" class="w-full">
      <mat-label>{{"Paid Content" | translate}}</mat-label>
      <mat-select ng-model="subscriptionType" [disabled]="!isSuperAdmin"
        (selectionChange)="selectPaidContent($event.value)" [value]="selectedPaidContent">
        <mat-option value="">{{'All' | translate}}</mat-option>
        <mat-option *ngFor="let itm of paidContentMeta.enum" [value]="itm.value">
          {{itm.displayName | translate}}</mat-option>
      </mat-select>
    </mat-form-field>
    <mat-form-field class="w-full">
      <input matInput #searchInput placeholder="{{'Search' | translate}}" [value]="searchVal">
    </mat-form-field>
    <mat-divider></mat-divider>
    <div style="position:relative">
      <mat-spinner [diameter]="30" *ngIf="loading" class="mat-spinner-color" color="warn" mode="indeterminate">
      </mat-spinner>
      <mat-nav-list style="min-height: 240px; max-height: 50vh; overflow-y: auto;">
        <mat-list-item *ngFor="let data of dataList" (click)="selectItemCheck(data)" class="tileListData">
          <div class="flex flex-row gap-[5px]" style="width: 100%;">
            <div class="flex-[75%] content-center max-w-[75%]">
              <a class="tileName" matLine href="Javascript:void(0)" title="{{ data.title }}">
                {{ data.title?.length > 20 ? ((data.title | slice:0:20) + '...') : data.title }}
              </a>
            </div>
            <div class="flex-[25%]" style="text-align: right;">
              <button class="deleteBtn" *ngIf="canDelete" mat-icon-button (click)="delete($event, data._id)">
                <mat-icon>cancel</mat-icon>
              </button>
            </div>
          </div>
        </mat-list-item>
      </mat-nav-list>
    </div>
  </mat-card-content>
  <mat-card-actions>
    <mat-paginator [hidePageSize]="true" [pageSize]="pageSize" [length]="paginatorTotal | async"
      [showFirstLastButtons]="true"></mat-paginator>
  </mat-card-actions>
</mat-card>